module.exports = __webpack_public_path__ + "img/连云港旧机动车交易市场有限公司.24ffe508.png";